<template>
	<b-sidebar width="100%" right shadow backdrop lazy v-model="isVisible">
		<template #header="{ hide }">
			<div class="d-flex align-items-center w-100 p-3 border-bottom">
				<b-icon icon="arrow-left" font-scale="1.2" class="mr-2" @click="hide" style="cursor: pointer;"></b-icon>
				<h5 class="mb-0">板块详情</h5>
			</div>
		</template>
		<div class="p-3">
			<h5>{{ symbol_name }}({{ symbol_code }}) 所属板块</h5>
			<div v-if="loading">加载中...</div>
			<div v-else class="row">
				<div v-for="(plate, index) in plates" :key="plate[0]" class="col-12 mb-3">
                    <div class="border p-2 rounded h-100">
                        <div class="d-flex justify-content-between align-items-center cursor-pointer" @click="togglePlate(index)" style="cursor: pointer;">
                            <span class="font-weight-bold">{{ plate[1] }}</span>
                            <span>
                                <b-badge variant="info" class="mr-2">幅: {{ plate[2] !== undefined ? Number(plate[2]).toFixed(2) + '%' : '-' }}</b-badge>
                                <b-icon :icon="expandedIndex === index ? 'chevron-up' : 'chevron-down'"></b-icon>
                            </span>
                        </div>

                        <div v-if="expandedIndex === index" class="mt-2">
                            <div v-if="plateStocks[plate[0]]" style="max-height: 400px; overflow-y: auto;" @scroll="handleScroll($event, plate[0])">
                                <table class="table table-sm table-hover small" v-if="plateStocks[plate[0]].length > 0">
                                    <thead>
                                        <tr>
                                            <th>股票</th>
                                            <th class="text-right">价格</th>
                                            <th class="text-right" @click="sortStocks(index, 'price_pct')" style="cursor: pointer;">
                                                涨幅
                                                <b-icon v-if="getSortIcon(plate[0], 'price_pct')" :icon="getSortIcon(plate[0], 'price_pct')" font-scale="0.8"></b-icon>
                                            </th>
                                            <th class="text-right" @click="sortStocks(index, 'leader_money')" style="cursor: pointer;">
                                                净额
                                                <b-icon v-if="getSortIcon(plate[0], 'leader_money')" :icon="getSortIcon(plate[0], 'leader_money')" font-scale="0.8"></b-icon>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="stock in plateStocks[plate[0]]" :key="stock.code">
                                            <td>
                                                <div>{{ stock.name }}({{ stock.code }})</div>
                                            </td>
                                            <td class="text-right align-middle">{{ Number(stock.price).toFixed(2) }}</td>
                                            <td class="text-right align-middle" :class="{'text-danger': stock.price_pct > 0, 'text-success': stock.price_pct < 0}">
                                                {{ stock.price_pct }}%
                                            </td>
                                            <td class="text-right align-middle" :class="{'text-danger': stock.leader_money > 0, 'text-success': stock.leader_money < 0}">
                                                {{ (stock.leader_money / 100000000).toFixed(2) }}亿
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="text-center text-muted py-2">无满足条件的股票 (涨幅>5%)</div>
                            </div>
                            <div v-else class="text-center text-muted py-2">
                                <b-spinner small type="grow"></b-spinner> 加载股票...
                            </div>
                        </div>
                    </div>
				</div>
                <div v-if="!loading && plates.length === 0" class="col-12 text-muted">暂无板块信息</div>
			</div>
		</div>
	</b-sidebar>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	export default {
		props: {
			symbol_code: String,
            symbol_name: String
		},
		data() {
			return {
				plates: [],
				plateStocks: {},
				loading: false,
				expandedIndex: -1,
                isVisible: false,
                sortStates: {},
                platePagination: {},
                targetPlateCode: null
			}
		},
        watch: {
            isVisible(val) {
                if (val) {
                    this.fetchPlates();
                }
            },
            symbol_code(val) {
                if (this.isVisible && val) {
					this.resetState();
                    this.fetchPlates();
                }
            }
        },
		methods: {
            resetState() {
                this.plates = [];
                this.plateStocks = {};
                this.expandedIndex = -1;
                this.sortStates = {};
                this.platePagination = {};
                this.loading = false;
                this.targetPlateCode = null;
            },
			fetchPlates() {
                if (!this.symbol_code) return;
                
                // Remove non-digit characters (like SH/SZ prefix) to ensure API compatibility
                let code = this.symbol_code.replace(/\D/g, '');

				this.loading = true;
				request_zzquant({
					url: '/v3/open/stock/' + code + '/info/12'
				}).then(res => {
                    // console.log('Plate info response:', res);
                    let list = null;
                    if (res.data && res.data.data) {
                        list = res.data.data['ListJX'];
                        // If ListJX is missing, try looking for List
                        if (!list && res.data.data['List']) {
                            list = res.data.data['List'];
                        }
                    }
                    
					if (list && list.length > 0) {
                        this.plates = list.sort((a, b) => (b[2] || 0) - (a[2] || 0));
                        
                        if (this.targetPlateCode) {
                            const index = this.plates.findIndex(p => p[0] == this.targetPlateCode);
                            if (index !== -1) {
                                this.expandedIndex = index;
                                this.fetchStocks(this.targetPlateCode);
                                
                                // Scroll to the expanded plate after DOM update
                                this.$nextTick(() => {
                                    // We need a ref or ID for each plate element to scroll to it
                                    // But since we don't have refs in the loop easily (unless we add them), 
                                    // we can try to rely on the expanded state being enough for now.
                                    // Or we can add refs. 
                                    // Let's just expand it for now.
                                });
                            }
                            this.targetPlateCode = null;
                        }
                    } else {
                        this.plates = [];
                    }
					this.loading = false;
				}).catch(err => {
					console.error(err);
					this.loading = false;
				});
			},
            show(plateCode = null) {
                this.isVisible = true;
                if (plateCode) {
                    this.targetPlateCode = plateCode;
                    // If plates are already loaded, we might want to expand immediately?
                    // But fetchPlates is called by watcher on isVisible=true.
                    // However, if isVisible was already true (re-opening?), watcher might not trigger if value didn't change?
                    // But show() sets isVisible=true. If it was false, it changes.
                    // If it was already true, watcher won't trigger.
                    if (this.plates.length > 0) {
                         const index = this.plates.findIndex(p => p[0] == plateCode);
                         if (index !== -1) {
                             // If already expanded same plate, do nothing? or toggle?
                             // User clicked specific plate, probably wants to see it.
                             if (this.expandedIndex !== index) {
                                 this.expandedIndex = index;
                                 this.fetchStocks(plateCode);
                             }
                             this.targetPlateCode = null;
                         }
                    }
                }
            },
            hide() {
                this.isVisible = false;
            },
            // ... rest of methods

			togglePlate(index) {
				if (this.expandedIndex === index) {
					this.expandedIndex = -1;
				} else {
					this.expandedIndex = index;
					const plate = this.plates[index];
					this.fetchStocks(plate[0]);
				}
			},
			fetchStocks(plateCode, loadMore = false) {
                // Init pagination state if not exists
                if (!this.platePagination[plateCode]) {
                    this.$set(this.platePagination, plateCode, { idx: 0, hasMore: true, loading: false });
                }
                
                const pagination = this.platePagination[plateCode];
                
                // If loading or no more data, return
                if (pagination.loading) return;
                if (loadMore && !pagination.hasMore) return;
                
                // Set loading
                pagination.loading = true;

                // Reset if not loading more
                if (!loadMore) {
                    pagination.idx = 0;
                    pagination.hasMore = true;
                }
                
                const sortKey = this.sortStates[plateCode]?.key || 'price_pct';
                // sort_by: 6 for price_pct (default), 1 for leader_money
                const sortBy = sortKey === 'leader_money' ? 1 : 6;
                
                const pageSize = 20;
                // idx is the start offset
                const idx = loadMore ? pagination.idx : 0;
                // lst is the count/limit
                const lst = pageSize;

				request_zzquant({
					url: `open/board/${plateCode}/stocks/sort`,
                    params: {
                        idx: idx,
                        lst: lst,
                        sort_by: sortBy
                    }
				}).then(res => {
                    let stocksRaw = [];
                    if (res.data && res.data.data && res.data.data.stocks && res.data.data.stocks.list) {
                        stocksRaw = res.data.data.stocks.list;
                    }
                    
                    // Map raw array to object
                    // 0: code, 1: name, 2: price, 3: price_pct, 10: leader_money
                    const newStocks = stocksRaw.map(item => ({
                        code: item[0],
                        name: item[1],
                        price: item[2],
                        price_pct: item[3],
                        leader_money: item[10]
                    }));

                    if (loadMore) {
                        const currentStocks = this.plateStocks[plateCode] || [];
                        this.plateStocks = { ...this.plateStocks,
                            [plateCode]: [...currentStocks, ...newStocks]
                        };
                    } else {
                        this.plateStocks = { ...this.plateStocks,
                            [plateCode]: newStocks
                        };
                    }

                    // Update pagination
                    pagination.idx += newStocks.length;
                    if (newStocks.length < pageSize) {
                        pagination.hasMore = false;
                    }
                    pagination.loading = false;
				}).catch(err => {
                    console.error("Fetch stocks failed", err);
                    if (!loadMore) {
                        this.plateStocks = { ...this.plateStocks,
                            [plateCode]: []
                        };
                    }
                    pagination.loading = false;
                });
			},
            handleScroll(e, plateCode) {
                const { scrollTop, clientHeight, scrollHeight } = e.target;
                if (scrollTop + clientHeight >= scrollHeight - 10) {
                    this.fetchStocks(plateCode, true);
                }
            },
			sortStocks(index, key) {
				const plate = this.plates[index];
                const plateCode = plate[0];
                
                if (!this.sortStates[plateCode]) {
                    this.$set(this.sortStates, plateCode, { key: 'price_pct', dir: 'desc' });
                }
                
                this.$set(this.sortStates, plateCode, { key: key, dir: 'desc' });
                this.fetchStocks(plateCode, false);
			},
            getSortIcon(plateCode, key) {
                if (!this.sortStates[plateCode] || this.sortStates[plateCode].key !== key) {
                    return null;
                }
                return this.sortStates[plateCode].dir === 'desc' ? 'arrow-down' : 'arrow-up';
            }
		}
	}
</script>

<style>
</style>
